import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormHolidays } from "../components/FormHolidays";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";

export const CreateHoliday: React.FC = () => {
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.holidays.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);

  return (
    <div>
      <FormHolidays pageType="create" />
    </div>
  );
};
